// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Translations$LiveRoom from "../../../../translations/Translations.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function NoAccess(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.zIndex(StyleConstants$LiveRoom.modalOnTopZIndex + 1 | 0),
                    tl: {
                      hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                      tl: {
                        hd: Css.minWidth(Css.px(486)),
                        tl: {
                          hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                hd: Css.minWidth("zero"),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: Css.margin4("zero", Css.px(16), Css.px(16), Css.px(16)),
                            tl: {
                              hd: Css.borderRadius(Css.px(4)),
                              tl: {
                                hd: Css.boxShadow(Css_Legacy_Core.Shadow.box(Css.px(0), Css.px(4), Css.px(16), Css.px(0), undefined, {
                                          NAME: "rgba",
                                          VAL: [
                                            0,
                                            0,
                                            0,
                                            {
                                              NAME: "num",
                                              VAL: 0.1
                                            }
                                          ]
                                        })),
                                tl: {
                                  hd: Css.padding(Css.px(32)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("column"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.textAlign("center"),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(SterlingIcons$LiveRoom.Collection.Exhibition48.make, {}), React.createElement(SterlingTypography$LiveRoom.Headline28Regular.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.margin4(Css.px(16), "zero", Css.px(8), "zero"),
                            tl: /* [] */0
                          }),
                      children: Curry._1(t, "SecretAuctions_RestrictedAccess")
                    }), React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                            tl: {
                              hd: Css.maxWidth(Css.px(400)),
                              tl: /* [] */0
                            }
                          }),
                      children: Curry._1(t, "SecretAuctions_RestrictedAccess_Description")
                    })), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("column"),
                          tl: {
                            hd: Css.marginTop(Css.px(24)),
                            tl: /* [] */0
                          }
                        }
                      })
                }, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.marginBottom(Css.px(16)),
                            tl: /* [] */0
                          }),
                      children: Curry._1(t, "SecretAuctions_RestrictedAccess_Contact")
                    }), React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.display("flex"),
                            tl: {
                              hd: Css.flexDirection("row"),
                              tl: {
                                hd: Css.alignItems("center"),
                                tl: /* [] */0
                              }
                            }
                          })
                    }, React.createElement(SterlingIcons$LiveRoom.Collection.Mobile24.make, {}), React.createElement(SterlingTypography$LiveRoom.Paragraph14LinkRegular.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.marginLeft(Css.px(8)),
                                tl: /* [] */0
                              }),
                          href: "tel: +1 212 606 7414",
                          children: null
                        }, Curry._1(t, "Common_us"), " +1 212 606 7414")), React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.display("flex"),
                            tl: {
                              hd: Css.flexDirection("row"),
                              tl: {
                                hd: Css.alignItems("center"),
                                tl: {
                                  hd: Css.marginTop(Css.px(4)),
                                  tl: /* [] */0
                                }
                              }
                            }
                          })
                    }, React.createElement(SterlingIcons$LiveRoom.Collection.Email24.make, {}), React.createElement(SterlingTypography$LiveRoom.Paragraph14LinkRegular.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.marginLeft(Css.px(8)),
                                tl: /* [] */0
                              }),
                          href: "mailto:bids.newyork@sothebys.com",
                          children: "bids.newyork@sothebys.com"
                        }))), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.flexDirection("row"),
                          tl: {
                            hd: Css.justifyContent("spaceBetween"),
                            tl: {
                              hd: Css.marginTop(Css.px(24)),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(Button.Button, {
                      onClick: (function (param) {
                          window.location = "https://www.sothebys.com?locale=" + Translations$LiveRoom.languageToJs(Translations$LiveRoom.getLanguage(undefined)) + "}";
                        }),
                      className: Curry._1(Css.style, {
                            hd: Css.marginRight(Css.px(8)),
                            tl: /* [] */0
                          }),
                      buttonStyle: "secondary",
                      children: Curry._1(t, "Common_close")
                    }), React.createElement(Button.Button, {
                      onClick: (function (param) {
                          window.location = "https://www.sothebys.com/calendar?locale=" + Translations$LiveRoom.languageToJs(Translations$LiveRoom.getLanguage(undefined)) + "}";
                        }),
                      className: Curry._1(Css.style, {
                            hd: Css.marginLeft(Css.px(8)),
                            tl: /* [] */0
                          }),
                      children: Curry._1(t, "SecretAuctions_RestrictedAccess_Button_UpcomingAuctions")
                    })));
}

var make = NoAccess;

export {
  make ,
}
/* Css Not a pure module */
